import { FC, useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { FormProvider, useForm } from 'react-hook-form';
import { useStore } from '@hooks/useStore';
import { SelectComponent } from '@inputs/SelectComponent/SelectComponent';
import { ICountryCodeData } from '@/types/common';
import { ICountryCodeSelectProps } from './types';
import { availabelUrls } from './constants';

export const CountryCodeSelect: FC<ICountryCodeSelectProps> = ({ stylesProp }) => {
  const {
    mainStore: { selectedCountryCode, setSelectedCountryCode },
    pointsStore: { setPointsCategories },
    profileStore: { user },
  } = useStore();
  const useFormMethods = useForm<{ country: ICountryCodeData | null }>({
    defaultValues: { country: selectedCountryCode },
  });
  const { setValue } = useFormMethods;
  const { pathname } = useLocation();

  useEffect(() => {
    setValue('country', selectedCountryCode);
  }, [selectedCountryCode]);

  const onCountryCodeSelect = useCallback(
    (countryCodeData: ICountryCodeData) => {
      if (user && selectedCountryCode?.countryCode !== countryCodeData.countryCode) {
        setPointsCategories(null);
        setSelectedCountryCode({ id: user.id, countryCodeData });
      }
    },
    [user, selectedCountryCode]
  );
  if (pathname === '/login' || !selectedCountryCode) return null;
  return (
    <div className={`absolute right-[48px] top-[24px] w-[224px] hide-on-mobile ${stylesProp}`}>
      <FormProvider {...useFormMethods}>
        <SelectComponent
          name="country"
          options={user?.usersCountryCodes || []}
          optionLabel="name"
          optionValue="countryCode"
          onSelect={onCountryCodeSelect}
          isClearable={false}
          styleProps={{ controlStyles: { border: '1px solid #2F5FE333' } }}
          isDisabled={!availabelUrls.includes(pathname)}
          menuPlacement="bottom"
        />
      </FormProvider>
    </div>
  );
};
